import React, { createContext, useState, useContext } from 'react';

// Create the context
const FullScreenContext = createContext();

export const useFullScreen = () => {
    return useContext(FullScreenContext);
};

export const FullScreenProvider = ({ children }) => {
    const [currentFullScreen, setCurrentFullScreen] = useState(false);

    const FullScreenMode = () => {
            setCurrentFullScreen(true);
    };

    const ExitFullScreenMode = () => {
        try {
                setCurrentFullScreen(false);
        } catch (err) {
            console.error("Unexpected error while exiting full-screen mode:", err);
        }
    };
    
    const value = {
        currentFullScreen,
        setCurrentFullScreen,
        FullScreenMode,
        ExitFullScreenMode
    };

    return (
        <FullScreenContext.Provider value={value}>
            {children}
        </FullScreenContext.Provider>
    );
};
